'use client';
import React, { useEffect, useState } from 'react';
import { handleFavoriteBrands } from '@/app/helpers/favoritebrands';
import { useDispatch, useSelector } from 'react-redux';
import { appSettingsState } from '@/app/lib/redux';

type Props = {
  brandId?: string;
  apiUrl?: string;
};

const FollowBrands = ({ brandId, apiUrl }: Props) => {
  const { user } = useSelector(appSettingsState);
  const dispatch = useDispatch();
  const [isFavoriteBrand, setIsFavoriteBrand] = useState(false);
  useEffect(() => {
    if (user?.WatchlistBrands) {
      const isInFavoriteBrands = user.WatchlistBrands.some((WatchlistBrand) => WatchlistBrand === brandId);
      setIsFavoriteBrand(isInFavoriteBrands);
    }
  }, [user?.WatchlistBrands, brandId]);

  const onFollowBrandClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    handleFavoriteBrands(user, isFavoriteBrand, dispatch, apiUrl, brandId);
  };

  return (
    <div onClick={onFollowBrandClick} className={'mb-2'}>
      {isFavoriteBrand && <button className={'btn btn-follow btn-black-hover-light'}>Following</button>}
      {!isFavoriteBrand && <button className={'btn-follow btn-white-hover-black btn'}>Follow</button>}
    </div>
  );
};

export default FollowBrands;
